import { measures as Measures } from '../hardcoded/scl';
import { getCountryName } from '../../helpers/map';

export const getRiskCategories = (data) => {
  if (data.riskByCategory) {
    const all = Object.keys(data.riskByCategory).reduce((a, authorId) => {
      if (typeof data.riskByCategory[authorId] === 'object' && !Array.isArray(data.riskByCategory[authorId])) {
        const keys = Object.keys(data.riskByCategory[authorId]).reduce((versions, v) => {
          if (Object.keys(data.riskByCategory[authorId][v]).length > 1 && data.riskByCategory[authorId][v].date) {
            versions[v] = data.riskByCategory[authorId][v];
          }
          return versions;
        }, {})
        if (Object.keys(keys).length) {
          a[authorId] = keys;
        }
      }
      return a;
    }, {});

    if (Object.keys(all).length > 1) {
      const versions = {};

      Object.values(all).forEach((v) => {
        Object.entries(v).forEach(([k, v]) => {
          if (versions[k]) {
            versions[k].push(v);
          } else {
            versions[k] = [v];
          }
        });
      });

      const values = Object.keys(versions).reduce((all, k) => {
        const items = versions[k];
        const neww = {};
        items.forEach((i) => {
          Object.keys(i).forEach((K) => {
            if (K !== 'date') {
              if (neww[K]) {
                neww[K] = neww[K] + (i[K] / items.length);
              } else {
                neww[K] = i[K];
              }
            }
          })
        });
        neww.date = items[0].date;
        if (Object.values(neww).find((v) => v > 0)) {
          all[k] = neww;
        }
        return all;
      }, {});

      return values;
    } else if (Object.keys(all).length === 1) {
      return Object.values(all)[0];
    }
  }
  return {};
};

const getFloat = (val) =>
  typeof val === 'string' ? parseFloat(val) : val;

export const getType = (o) => {
  if (typeof o.completedAt === 'string') {
    return 'completed'
  }

  if ((o.events || []).length) {
    return 'inProgress';
  }

  return 'proposed';
};

const findC = (code) => {
  const f = Measures.options.area.find((c) => c.value === code);

  if (f) {
    return f.label;
  }
  return '';
};

export const mapScl = (data, language, associatedEvents = []) => {
  if (data && data.subjectDetails && data.options) {
    const documents = [];
    const images = [];
    if (data.documentation && Array.isArray(data.documentation)) {
      data.documentation.forEach((file) => {
        if (file.type === 'image') {
          images.push({
            type: 'image',
            title: file.name,
            url: file.url,
            source: file.source,
          });
        } else if (file.type === 'document') {
          documents.push({
            type: 'document',
            title: file.name,
            name: file.url,
            source: file.source,
          });
        }
      })
    }

    const subjectDetails = {
      subjectName: data.subjectDetails ? data.subjectDetails.subjectName : '',
      datastakeId: data.datastakeId,
    };

    const riskHistory = { data: {} };
    const scl = {
      documents,
      images,
      name: subjectDetails.subjectName,
      stakeholdersAssociated: data.subjectDetails.stakeholdersAssociated,
    };
    let aL1;
    let aL2;
    let country;

    if (data.subjectDetails.administrativeLevel1) {
      aL1 = data.subjectDetails.administrativeLevel1.name;
      country = getCountryName(data.subjectDetails.administrativeLevel1.country);
    }

    if (data.subjectDetails.administrativeLevel2) {
      aL2 = data.subjectDetails.administrativeLevel2.name;
    }

    if (aL1 && aL2 && country) {
      scl.locationName = `${country} / ${aL1} / ${aL2}`;
    }

    let village = null;
    let town = {};

    if (data.subjectDetails.village && data.subjectDetails.village.gps) {
      const country = findC(data.subjectDetails.village.country);
      const aL1 = data.subjectDetails.village.administrativeLevel1;
      const aL2 = data.subjectDetails.village.administrativeLevel2;

      village = {
        coordinates: {
          lat: getFloat(data.subjectDetails.village.gps.latitude),
          lng: getFloat(data.subjectDetails.village.gps.longitude),
        },
        name: data.subjectDetails.village.name,
        locationName: `${country}/${aL1}/${aL2}`,
        stakeholdersAssociated: data.subjectDetails.village.stakeholdersAssociated,
      };
    }

    if (data.subjectDetails.exportTown && data.subjectDetails.exportTown.gps) {
      const country = findC(data.subjectDetails.exportTown.country);
      const aL1 = data.subjectDetails.exportTown.administrativeLevel1;
      const aL2 = data.subjectDetails.exportTown.administrativeLevel2;

      town = {
        coordinates: {
          lat: getFloat(data.subjectDetails.exportTown.gps.latitude),
          lng: getFloat(data.subjectDetails.exportTown.gps.longitude),
        },
        name: data.subjectDetails.exportTown.name,
        locationName: `${country}/${aL1}/${aL2}`,
        stakeholdersAssociated: data.subjectDetails.exportTown.stakeholdersAssociated,
      };
    }

    const getTypeOfMiningOperations = (val) => {
      if (data.options.typeOfMiningOperationsOptions) {
        const v = data.options.typeOfMiningOperationsOptions.find((s) => s.value === val);
        if (v) {
          return v.label ? v.label[language] || v.label.en : null;
        }
      }
      return null;
    }

    if (data.subjectDetails) {
      scl.associatedEvents = associatedEvents.length || 0;
      scl.monitoredRisks = data.subjectDetails.monitoredRisks || 0;
      scl.accessTimeToExportTown = data.subjectDetails.accessTimeToExportTown;
      scl.accessTimeToMiningVillage = data.subjectDetails.accessTimeToMiningVillage;
      scl.distanceToExportTown = data.subjectDetails.distanceToExportTown;
      scl.distanceToMiningVillage = data.subjectDetails.distanceToMiningVillage;
      if (data.options && data.options.mineralOptions) {
        scl.products = data.subjectDetails.products.map((p) => {
          const pr = (data.options.mineralOptions || []).find((pp) => pp.value === p);
          if (pr) {
            return pr.label[language] || pr.label.en || '-';
          }
          return p || '-';
        }) || [];
      }
      scl.proposedMeasures = data.subjectDetails.proposedMeasures || 0;
      scl.operator = data.subjectDetails.operator ? data.subjectDetails.operator.name : null;
      scl.typeOfMiningOperation = getTypeOfMiningOperations(data.subjectDetails.typeOfOperation);
      scl.score = data.subjectDetails.riskScore;
      if (data.subjectDetails.gps) {
        scl.coordinates = {
          lat: getFloat(data.subjectDetails.gps.latitude),
          lng: getFloat(data.subjectDetails.gps.longitude),
        }
      }
    }

    if (data.riskHistory) {
      riskHistory.data = data.riskHistory;
    }


    const riskCategories = getRiskCategories(data);

    const events = associatedEvents || [];

    const getRiskSubCat = (val) => {
      if (data.options.riskSubcategoriesOptions) {
        const a = data.options.riskSubcategoriesOptions.find((o) => o.value === val);
        if (a) {
          return { label: a.label[language] };
        }
        return { label: '' };
      }
    }

    const getMeasure = (val) => {
      const { recommendedMeasureOptions } = data.options;
      const meas = (recommendedMeasureOptions || []).find((m) => m.value === val);
      if (meas) {
        return meas.label[language] || meas.label.en;
      }
      return val;
    };

    const getRiskRecMeasure = (val) => {
      if (data.options.recommendedMeasureOptions) {
        const a = data.options.recommendedMeasureOptions.find((o) => o.value === val);
        if (a) {
          return { label: a.label[language] };
        }
        return { label: '' };
      }
    }

    const riskMaterialisation = data.riskMaterialisation ? data.riskMaterialisation.map((r) => ({
      impact: r.impact,
      threat: r.threat,
      incidents: r.incidents,
      type: r.category,
      title: (getRiskSubCat(r.type) || {}).label,
    })) : [];

    const riskMitigation = data.riskMitigation ? data.riskMitigation.map((r) => ({
      ...r,
      type: getType(r),
      "createdAt": r.proposedDate || r.createdAt,
      // Map with options
      measure: (getRiskRecMeasure(r.measure) || {}).label,
      riskSubcategory: (getRiskSubCat(data.risk) || {}).label,
    })) : [];

    const getRiskCategory = (cat) => {
      const { riskCategories } = data.options || [];
      const category = (riskCategories || []).find((r) => r.value === cat);
      if (category && category.label) {
        return category.label[language] || category.label.en
      }
      return cat;
    }

    const getMeasures = () => {
      if (data.correctiveMeasures && subjectDetails) {
        const meassures = data.correctiveMeasures;
        const keys = Object.keys(meassures);
        const sections = {};

        const getCompletionStatus = (o) => {
          if (typeof o.completedAt === 'string') {
            return 'completed'
          }

          if ((o.events || []).length) {
            return 'inProgress';
          }

          return 'proposed';
        }

        const mapEvents = (measureEvents = []) => {
          const maped = measureEvents.map((evId) => {
            const ev = events.find((e) => e.id === evId);
            if (ev) {
              return { ...ev, location: subjectDetails.subjectName || ev.location };
            }
            return undefined;
          })
            .filter((ev) => ev);
          return maped;
        };

        keys.forEach((k) => {
          sections[k] = getRiskSubCat(k);
        });

        const options = { ...Measures.options, ...data.options };
        keys.forEach((k) => {
          meassures[k] = data.correctiveMeasures[k].map((o) => ({
            ...o,
            events: mapEvents(o.events || []),
            measure: getMeasure(o.measure),
            completionStatus: getCompletionStatus(o),
            proposedDate: o.createdAt || o.proposedDate,
            objective: 'reduceVulnerability',
            locationType: 'Mine Site',
            category: scl.category,
            area: subjectDetails.subjectName,
            riskType: (sections[k] || []).label,
            riskCategory: getRiskCategory(o.category),
            riskTypeCamelCase: o.category,
            riskCategoryCamelCase: o.risk,
          }));
        })
        return { data: meassures, sections, options };
      }
      return null;
    };

    const measures = getMeasures();

    const getStakeholderMapping = () => {
      const location = { id: data.subjectDetails.id, name: subjectDetails.subjectName };
      const stakeholders = [];
      const groups = [];

      if (data.stakeholderMapping) {
        Object.entries(data.stakeholderMapping).forEach(([k, v]) => {
          groups.push(k);
          stakeholders.push(...v);
        });
      }
      return { location, stakeholders, groups };
    };

    const stakeholdersMapping = getStakeholderMapping();

    return {
      subjectDetails,
      riskHistory,
      events,
      map: { scl, village, town },
      riskMaterialisation,
      riskMitigation,
      measures,
      stakeholdersMapping,
      riskCategories,
    };
  }
  return {};
}
